<template>
    <v-expansion-panel>
        <v-expansion-panel-header>Basis Informationen</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-row>
                <v-col class="col-6">
                    <v-switch v-model="postItem.is_active" flat label="Veröffentlicht"></v-switch>
                    <v-switch v-model="postItem.is_featured" flat label="Featured"></v-switch>
                </v-col>
                <v-col class="col-6">
                    <v-select
                            :items="typeOfPost"
                            label="Typ des Posts"
                            :value="postItem.type"
                            v-model="postItem.type"
                            @change="rebuildContent"
                            required
                    ></v-select>

                    <v-select
                            :items="postCategories"
                            label="Kategorie wählen"
                            :value="postItem['new_category_id']"
                            v-model="postItem['new_category_id']"
                            required
                    ></v-select>

                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-12">
                    <v-text-field
                            v-model="blogTitle"
                            :counter="75"
                            label="Titel"
                            required
                    ></v-text-field>
                    <vue-editor :editorToolbar="basicInformationToolbar" v-model="postItem.opener_text" id="openerTextEdit"></vue-editor>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-12">
                    <v-text-field label="Rezeptüberschrift nach Slider" v-model="postItem.recipe_title" v-if="postItem.type === 'Rezept'"></v-text-field>
                    <v-switch v-model="recipeTitleAsSEO" flat label="Rezeptüberschrift nach Slider als SEO - Titel benutzten?"
                              v-if="postItem.type === 'Rezept'"
                    ></v-switch>
                    <v-text-field
                            v-model="dreiscSeoUrl"
                            :counter="75"
                            label="SEO Titel"
                            required
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-12">
                    <Tags :post-item="postItem"></Tags>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <v-menu
                            ref="menu"
                            v-model="datePickerMenu"
                            :close-on-content-click="false"
                            :return-value.sync="postItem.publishing_date_from_date"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                    v-model="postItem.publishing_date_from_date"
                                    label="Datum und der Veröffentlichung:"
                                    prepend-icon="event"
                                    readonly
                                    v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="postItem.publishing_date_from_date" no-title scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="datePickerMenu = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.menu.save(postItem.publishing_date_from_date)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="6">
                    <v-menu
                            ref="menu2"
                            v-model="timePickerMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="postItem.publishing_date_from_time"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                    v-model="postItem.publishing_date_from_time"
                                    label="Uhrzeit der Veröffentlichung:"
                                    prepend-icon="access_time"
                                    readonly
                                    v-on="on"
                            ></v-text-field>
                        </template>
                        <v-time-picker
                                v-if="timePickerMenu"
                                v-model="postItem.publishing_date_from_time"
                                format="24hr"
                                full-width
                                @click:minute="$refs.menu2.save(postItem.publishing_date_from_time)"
                        ></v-time-picker>
                    </v-menu>
                </v-col>
            </v-row>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
  import { VueEditor } from "vue2-editor";
  import Tags from './subComponents/Tags'
  import urlSlug from 'url-slug';

  export default {
    name: 'PostBasicInformation',
    props: ['postItem'],
    components:{
      VueEditor,
      Tags
    },
    beforeMount () {
      if(this.postItem.blog_title != ''){
        this.blogTitle = this.postItem.blog_title;
      }
      if(this.postItem.dreisc_seo_url === null || this.postItem.dreisc_seo_url === ''){
        this.dreiscSeoUrl = urlSlug(this.postItem.blog_title,{});
      }else{
        this.recipeTitleAsSEO = true;
      }
    },
    data: () => {
      return {
        blogTitle:'',
        recipeTitleAsSEO:false,
        dreiscSeoUrl: '',
        datePickerMenu: false,
        basicInformationToolbar: [["bold", "italic", "underline","link"], [{ list: "ordered" }, { list: "bullet" }]],
        timePickerMenu: false,
        newCategory:0,
        typeOfPost: [
          {text:'Rezept', value:'Rezept', selected:false},
          {text:'OnTour', value:'OnTour', selected:false},
          {text:'Technikwelt', value:'Technikwelt', selected:false}
        ],
      }
    },
    computed:{
      postCategories (){
        return this.$store.getters.getPostCategories
      }
    },
    methods:{
      rebuildContent(){
        this.postItem.opener_images = [];
        this.postItem.content_container = []
        this.postItem.recipe_container = []
      }
    },
    watch: {
      newCategory(val){
        this.postItem.new_category_id = val;
      },
      recipeTitleAsSEO(val){
        if(val){
          this.dreiscSeoUrl = urlSlug(this.postItem.recipe_title,{})
          this.postItem.dreisc_seo_url = this.dreiscSeoUrl;
        }else{
          this.dreiscSeoUrl = urlSlug(this.postItem.blog_title,{});
          this.postItem.dreisc_seo_url = this.dreiscSeoUrl;
        }
      },
      dreiscSeoUrl(val){
        this.dreiscSeoUrl = urlSlug(val,{});
        this.postItem.dreisc_seo_url = this.dreiscSeoUrl;
      },
      blogTitle(val){
        if(!this.recipeTitleAsSEO){
          this.dreiscSeoUrl = urlSlug(val);
        }
        this.blogTitle = val;
        this.postItem.blog_title = val;
      }
    }
  }
</script>

<style scoped>

</style>